import {
  ChatProspectStage,
  SalesPortalManagerPipelineSummaryQuery,
  SalesPortalManagerProspectForecastQuery,
  SalesPortalManagerProspectsQuery,
  SalesPortalManagerRepSummariesQuery,
  SalesPortalRepViewProspectsQuery,
} from '@/types';

export interface RepViewProspectRowData {
  address: string;
  dateAddedAt: string;
  dateAddedDisplay: string;
  lastActivityAt?: string;
  lastActivityDisplay: string;
  name: string;
  restaurantUUID: string;
  supplierUUID: string;
  weeklyValueDisplay: string;
  weeklyValueInMicros?: number;
}

export enum RepViewColumnId {
  DateAdded = 'dateAdded',
  LastActivity = 'lastActivity',
  Name = 'name',
  Value = 'value',
}

export type RepViewProspectQueryRow =
  SalesPortalRepViewProspectsQuery['getSalesPortalProspectListInfo'][number];

export type ManagerProspectQueryRow =
  SalesPortalManagerProspectsQuery['getSalesPortalManagerProspectList'][number];

export interface ManagerProspectRowData {
  daysSinceTouch?: number;
  daysSinceTouchDisplay: string;
  name: string;
  prospectUUID: string;
  repName: string;
  repUUID?: string;
  restaurantUUID: string;
  stage: ChatProspectStage;
  supplierUUID: string;
  weeklyValueDisplay: string;
  weeklyValueInMicros?: number;
}

export enum ManagerFilterId {
  Rep = 'rep',
  Stage = 'stage',
}

export enum ManagerProspectColumnId {
  LastActivity = 'lastActivity',
  Name = 'name',
  Stage = 'stage',
  Value = 'value',
}

export type ManagerRepSummaryQueryRow =
  SalesPortalManagerRepSummariesQuery['getSalesPortalManagerRepSummaries'][number];

export enum ManagerRepTimeRange {
  Mtd = 'mtd',
  Wtd = 'wtd',
  Ytd = 'ytd',
}

export interface ManagerRepRowData {
  avgConversionDays?: number;
  avgConversionDaysDisplay: string;
  conversionRate?: number;
  conversionRateDisplay: string;
  noteCount: number;
  repName: string;
  repUUID: string;
  weeklyValueDisplay: string;
  weeklyValueInMicros?: number;
}

export enum ManagerRepColumnId {
  AvgTime = 'avgTime',
  Conversion = 'conversion',
  Notes = 'notes',
  Rep = 'rep',
  Value = 'value',
}

export type ManagerForecastWindowQueryRow =
  SalesPortalManagerProspectForecastQuery['getSalesPortalManagerProspectForecast'][number];

export enum ManagerForecastTileId {
  Closing7 = 'closing7',
  Closing30 = 'closing30',
  Closing60 = 'closing60',
}

export interface ManagerForecastTileData {
  id: ManagerForecastTileId;
  label: string;
  prospectCountDisplay: string;
  totalValueDisplay: string;
}

export type ManagerPipelineStageQueryRow =
  SalesPortalManagerPipelineSummaryQuery['getSalesPortalManagerPipelineSummary'][number];

export interface ManagerPipelineStageData {
  prospectCount: number;
  prospectCountDisplay: string;
  prospectCountLabel: string;
  stage: ChatProspectStage;
  stageLabel: string;
  totalValueDisplay: string;
  totalValueInMicros: number;
}
